export const authClear = 'AUTH_CLEAR';
export const authSetJwt = 'AUTH_SET_JWT';
export const authSetLocal = 'AUTH_SET_LOCAL';
export const logout = 'LOGOUT';

export default {
    setJwt: authSetJwt,
    setLocal: authSetLocal
};
